import React from "react";
import { EventType } from "../../../../models/EventType";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "../../../../design/table";
import { Subheading } from "../../../../design/heading";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import DeleteEventTypeButton from "./DeleteEventTypeButton";
import DeleteEventSubtypeButton from "./DeleteEventSubtypeButton";
import { EventSubtype } from "../../../../models/EventSubtype";
import EventSubtypeBadge from "../../../../components/EventSubtypeBadge";

interface EventTypeListItemProps {
  matterTypeId: string;
  eventType: EventType;
  eventSubtypes: EventSubtype[];
}

const EventTypeListItem: React.FC<EventTypeListItemProps> = ({
  matterTypeId,
  eventType,
  eventSubtypes,
}) => {
  const items = eventSubtypes.filter(
    (item) => item.eventType === eventType._id,
  );
  return (
    <div className="mt-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 mb-2">
          <Subheading className="font-bold">{eventType.name}</Subheading>
          <ChevronRightIcon className="w-4 h-4 fill-zinc-400 dark:fill-zinc-500" />
        </div>
        <DeleteEventTypeButton
          matterTypeId={matterTypeId}
          eventTypeId={eventType._id}
        />
      </div>
      <Table>
        <TableBody>
          {items.map((eventSubtype) => {
            return (
              <TableRow key={eventSubtype._id}>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <EventSubtypeBadge
                      eventSubtypeId={eventSubtype._id}
                      eventSubtypes={eventSubtypes}
                    />
                  </div>
                  <div className="whitespace-pre-line">
                    {eventSubtype.description}
                  </div>
                </TableCell>
                <TableCell width={20}>
                  <DeleteEventSubtypeButton
                    matterTypeId={matterTypeId}
                    eventSubtypeId={eventSubtype._id}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default EventTypeListItem;
